<template>
  <div class="Meta-Container">
    <div class="Container">
      <div class="Column">
        <div class="Row">
          <input type="text" v-model="firstname" class="Input Input-Right" :placeholder="$t('forms.firstname')" />

          <input type="text" v-model="lastname" class="Input" :placeholder="$t('forms.lastname')" />
        </div>

        <div class="Row">
          <input type="text" v-model="society" class="Input" :placeholder="$t('forms.society')" />
        </div>

        <div class="Row">
          <input type="text" v-model="phoneNumber" class="Input" :placeholder="$t('forms.phone')"/>
        </div>

        <div class="Row">
          <input type="text" v-model="birthday" class="Input" :placeholder="$t('forms.birthday')"/>
        </div>
      </div>

      <div class="Column">
        <div class="Row">
          <input type="text" v-model="address" class="Input" :placeholder="$t('forms.billingAddress')"/>
        </div>

        <div class="Row">
          <input type="text" v-model="complement" class="Input" :placeholder="$t('forms.billingComplement')"/>
        </div>

        <div class="Row">
          <input type="text" v-model="postalCode" class="Input Input-Right" :placeholder="$t('forms.billingPostalCode')"/>

          <input type="text" v-model="city" class="Input" :placeholder="$t('forms.billingCity')"/>
        </div>

        <div class="Row Special">
          <select v-model="country" class="Input Input-Special">
            <option value="">{{ $t('forms.country') }}</option>
            <option v-for="country in countries" :value="country" :key="country">{{ country }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="Submit-container">
      <div class="Submit" @click="saveBillingAddress" v-if="!this.isSaving">
        {{ $t('shop.cartInformations.saveInformations') }}
      </div>
      <div class="Loader-Wrapper" v-else>
        <loader />
      </div>
    </div>
  </div>

</template>

<script>
import user from "@/mixins/user";
import Loader from "@/components/common/Loader";

export default {
  name: 'CartUserInformations',
  components: { Loader },
  data: () => ({
    firstname: '',
    lastname: '',
    society: '',
    phoneNumber: '',
    birthday: '',
    address: '',
    complement: '',
    postalCode: '',
    city: '',
    country: '',
    countries: [
      'France'
    ],
    loaded: false,
    isSaving: false
  }),
  mixins: [user],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.isUserLogged && !this.loaded) {
        this.firstname = this.user.firstname
        this.lastname = this.user.lastname
        this.society = this.user.billingEnterprise
        this.phoneNumber = this.user.phoneNumber
        this.birthday = this.user.birthday

        const shippingForBilling = this.user.shippingForBilling || true

        if (shippingForBilling) {
          // Billing address is shipping address
          this.address = this.user.shippingAddress
          this.complement = this.user.shippingComplement
          this.postalCode = this.user.shippingPostalCode
          this.city = this.user.shippingCity
        } else {
          this.address = this.user.billingAddress
          this.complement = this.user.billingComplement
          this.postalCode = this.user.billingPostalCode
          this.city = this.user.billingCity
        }
      }
    },
    async saveBillingAddress() {
      const updatePayload = {
        billingAddress: this.address,
        billingComplement: this.complement,
        billingPostalCode: this.postalCode,
        billingCity: this.city,
        country: this.country,
        firstname: this.firstname,
        lastname: this.lastname,
        billingEnterprise: this.society,
        phoneNumber: this.phoneNumber,
        birthday: this.birthday
      }

      this.isSaving = true

      // TODO

      try {
        await this.updateUserInformations(updatePayload)
      } catch (error) {
        if (error.code) {
          this.errorMessage = error.code
        }
      }

      this.isSaving = false
    }
  },
  watch: {
    user() {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  display: flex;
  flex-direction: Row;
  flex-grow: 1;

  @media (max-width: 450px) {
    flex-direction: column;
  }
}

.Column {
  display: flex;
  flex-grow: 1;
  flex-direction: Column;

  &:first-child {
    margin-right: 30px;

    @media (max-width: 450px) {
      margin-right: 0;
    }
  }

  &:last-child {
    margin-left: 30px;

    @media (max-width: 450px) {
      margin-left: 0;
    }
  }
}

.Input {
  border: 2px solid #979a9a;
  display: flex;
  flex-grow: 1;
  height: 39px;

  @media (max-width: 450px) {
    width: 100%;
  }
}

.Input-Left {
  margin-left: 9px;
}

.Input-Right {
  margin-right: 9px;
}

.Submit-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Submit {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 29px;
  width: 300px;
  border-radius: 26px;
  background-color: $primary;
  text-align: center;
  color: white;
  height: 51px;
  font-weight: bold;
  font-size: 20px;
}

.Row {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  margin-top: 37px;
  align-items: center;

  @media (max-width: 450px) {
    margin-top: 20px;
  }

  .Input:only-child {
    margin: 0;
  }
}

.Special {
  @media (max-width: 450px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-right: 0;
  }
}

.SaveAdress {
  flex-basis: 50%;
  color: $primary;

  @media (max-width: 450px) {
    flex-basis: auto;
  }
}

.Loader-Wrapper {
  margin-top: 29px;
}
</style>